export class InstanceStatus {
    readonly ok?: string;
    readonly invalid?: string;

    constructor(ok, invalid) {
        this.ok = ok;
        this.invalid = invalid;
    }
}

export interface InstanceConfig {
    /** Identifier of this instance whithin the cloud provider */
    id: string;

    /** Human friendly name, if present */
    name: string;

    /** */
    status: InstanceStatus;
}

export class Instance {

    /** Identifier of this instance whithin the cloud provider */
    id: string;

    /** Human friendly name, if present */
    name: string;

    /** */
    status: InstanceStatus;


    constructor(props: InstanceConfig) {
        this.id = props.id;
        this.name = props.name;
        this.status = props.status;
    }

}